<template>
  <div class="cb-pheader__wrap">
  	<div class="cb-pheader__logo" v-if="logo">
	    <img class="cb-pheader__image" :src="logo">
		</div>
		<div class="cb-pheader__content">
      {{t("header.txt", {total: valid_invoices.length, amount: $options.filters.cbCurrency(totalDue, currency_code)})}}
		</div>
		<div class="cb-pheader__actions">
			<div class="cb-pheader__action">
				<cb-button :attr="'pay_now'" :custom-class="'primary'" @next = "next" :class="{'cb-button__disabled':btn_disabled}" :aria-disabled="btn_disabled" :btnDisabled="btn_disabled" :disabled="btn_disabled">
					{{ t("button.txt", {amount: $options.filters.cbCurrency(amountToBePaid, currency_code) }) }} <i class="icon-long-arrow-right"></i>
        </cb-button>
        <div class="cb-pheader__subscribe"><i class="icon-lock" aria-hidden="true"></i>{{st('checkout_message')}}
          <span v-if="!hideBranding">
            {{st('chargebee_checkout')}}
          </span>
        </div>
			</div>
		</div>
  </div>
</template>
<script type="text/javascript">
import Vue from "vue"
import {
  mapGetters
} from "vuex"
import Button from "@/components/collections/form/ButtonComponent"
export default {
	data(){
    return {

    }
	},
	components : {
		'cb-button' : Button,
	},
	computed: {
    ...mapGetters([
      'valid_invoices',
      'totalDue',
      'amountToBePaid',
      'currency_code'
    ]),
    btn_disabled(){
      return this.amountToBePaid <= 0;
    },
    hideBranding() {
      return window && window.initInfo && window.initInfo.hide_branding;
    }
  },
  methods: {
  	next(){
      if (!~this.$route.path.indexOf('paynow')) {
        if(this.amountToBePaid <= 0){
          return;
        }
        this.$store.dispatch('set_modal',true);
        this.$router.push({
          name: "paynow"
        });
      }
  	}
  },
}
</script>
